import React, { useState, Suspense } from 'react';
import PropTypes from 'prop-types';

const Loader = React.lazy(
  () => import('../../../Components/Loader/LoaderComponent.component')
);
const DestructiveButton = React.lazy(
  () =>
    import(
      '../../../Components/Buttons/DestructiveButton/DestructiveButton.component'
    )
);
const Modal = React.lazy(
  () => import('../../../Components/Modal/ModalComponent.component')
);

const ConfirmDeleteButton = ({ onDelete, itemName }) => {
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteSubmit = async () => {
    setLoading(true);
    try {
      await onDelete();
      setIsModalOpen(false);
    } catch (err) {
      console.error('Error deleting item:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Suspense fallback={<p>Loading button...</p>}>
        <DestructiveButton
          functionName={() => setIsModalOpen(true)}
          span={`Delete ${itemName}`}
        />
      </Suspense>
      {isModalOpen && (
        <Suspense fallback={<p>Loading modal...</p>}>
          <Modal onClose={() => setIsModalOpen(false)}>
            <h2>Confirm Delete</h2>
            <p>Are you sure you want to delete {itemName}?</p>
            <Suspense fallback={<p>Loading loader...</p>}>
              {loading ? (
                <Loader />
              ) : (
                <div>
                  <Suspense fallback={<p>Loading button...</p>}>
                    <DestructiveButton
                      functionName={handleDeleteSubmit}
                      span="Confirm Delete"
                      // type="button"
                    />
                  </Suspense>
                </div>
              )}
            </Suspense>
          </Modal>
        </Suspense>
      )}
    </>
  );
};

ConfirmDeleteButton.propTypes = {
  onDelete: PropTypes.func,
  itemName: PropTypes.string,
};

export default ConfirmDeleteButton;
